import { LoggerService } from '../../services/logger.service';
import { StaffAuthService } from '../../services/staff-auth.service';
import { AppMessages } from 'app/shared/consts/app-messages';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { Component, OnInit, EventEmitter, Output, ElementRef, ViewChild, Input, Renderer2, HostListener } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Ng2ImgMaxService } from 'ng2-img-max';

import * as _ from 'lodash';
import { AppConsts } from 'app/shared/consts/app-consts';
import { menuHome } from '../../../config/config';
import { Router } from '@angular/router';

declare var Swiper: any;
declare var $: any;
@Component({
  selector: 'html5-camera',
  templateUrl: './html5-camera.component.html',
  styleUrls: ['./html5-camera.component.scss'],
})
export class Html5CameraComponent implements OnInit {
  @ViewChild('video', { static: true }) videoElement: ElementRef;
  @ViewChild('canvas', { static: true }) canvas: ElementRef;
  @Output()
  public captureEvent = new EventEmitter<string>();
  @Output()
  public offCameraEvent = new EventEmitter();
  @Input()
  public cancelableCamera: boolean = false;
  public webcamImage: WebcamImage;
  public isShowWebcam : boolean = true;
  public showGuide: boolean = false;
  public showRightCapture: boolean = false;
  public showWrongCapture: boolean = false;
  public showMessageBox: boolean = false;
  public message: string;
  public allowUpload: boolean = false;

  public videoWidth = 0;
  public videoHeight = 0;

  private fileSelectorFlg: boolean = false;
  public fileObject: any;

  // Camera message
  public cameraIssueVisible: boolean = false;
  public cameraIssueMessage: string = '';

  // Camera type
  public cameraType: string = 'type1';

  public isSkipPII: boolean = false;


  public cStream: any;

  constructor(
    private staffService: StaffAuthService, 
    private loggerService: LoggerService,
    private renderer: Renderer2,
    private resizeService: Ng2ImgMaxService,
    private router: Router) {
    }

  hdConstraintsFacingMode = {
    video: {
        width: {
            min: 1280
        },
        height: {
            min: 720
        },
        facingMode: {
            exact: "environment"
        }
    },
    audio: false
  };
  async ngOnInit() {
    // Nếu trình duyệt là zalo hoặc FB thì không cho sử dụng luôn
    var agent = navigator.userAgent.toLocaleLowerCase();
    this.isSkipPII = this.staffService.currentUserValue.skipPIIEnable;
    if(this.isInvalidBrowser(agent))
    {
      return;
    }
    if(this.staffService.currentCampaignConfig && this.staffService.currentCampaignConfig.allowUploadImage)
    {
      this.allowUpload = true;
    }

    if(this.staffService.currentCampaignConfig 
      && this.staffService.currentCampaignConfig.cameraType)
      {
        this.cameraType = this.staffService.currentCampaignConfig.cameraType;
      }

    if(this.cameraType == AppConsts.cameraType.external)
    {
      this.startExternalCamera();
    }
    else
    {
      await this.startCamera();
    }
  }




  private isInvalidBrowser(userAgent: string)
  {
    userAgent = userAgent.toLocaleLowerCase();
    if(userAgent && userAgent.indexOf('zalo') != -1)
    {
      this.cameraIssueVisible = true;
      this.cameraIssueMessage = AppMessages.ZALO_BROWSER_ERROR;
      return true;
    }

    if((userAgent.indexOf("fban") > -1) || (userAgent.indexOf("fbav") > -1))
    {
      this.cameraIssueVisible = true;
      this.cameraIssueMessage = AppMessages.FB_BROWSER_ERROR;
      return true;
    }
    return false;
  }

  public closeCameraIssue(event: any)
  {
    this.cameraIssueVisible = false;
    this.offCamera();
  }

  private isExceptionCamera() {
    var agent = navigator.userAgent.toLocaleLowerCase();
    return agent.match(/sm-n975f|sm-g985f|sm-g980f|sm-a515|sm-j600/i) || agent.match(/cph2043|sm-g960|sm-g965/i);
    //return agent.match(/sm-g985f|sm-g980f|sm-a515|sm-j600/i) || agent.match(/cph2043|sm-g960|sm-g965/i);
  }

  private getUserAgent()
  {
    return navigator.userAgent;
  }

  private startExternalCamera()
  {
    $('#externalCamera').click();
  }

  async startCamera() {
    var base = this;
    var media = null;
    var constraint: any = this.hdConstraintsFacingMode;
    if(window.navigator.mediaDevices)
    {
      media = window.navigator.mediaDevices;
    }
    else
    {
      media = navigator.mediaDevices;
    }
    if (!!(media && media.getUserMedia)) {
      if (this.isExceptionCamera())
      {
        await media.getUserMedia({video: true});
        var devices = await media.enumerateDevices();
        var deviceIds: string[] = [];
        devices.forEach(function (x) {
          if (x.kind == 'videoinput' && (x.label == '' || x.label.includes('back')))
          {
            deviceIds.push(x.deviceId);
          }
        });
        if (deviceIds)
        {
          deviceIds.reverse();
          constraint = {
            video: {
                width: {
                    min: 1280
                },
                height: {
                    min: 720
                },
                deviceId: { exact: deviceIds[0] }
            },
            audio: false
          };
        }
      }
      media.getUserMedia(constraint).then(this.attachVideo.bind(this)).catch(function (error) {
        if ((error.name == 'NotAllowedError') ||
          (error.name == 'PermissionDismissedError')) {
          base.message = AppMessages.NOT_ACCESS_CAMERA;
        }
        if(error)
        {
          base.loggerService.logger(base.getUserAgent() + '@' + error.name, 'UgiftCamera');
        }
        if(base.cameraType == AppConsts.cameraType.complex)
        {
          $('#externalCamera').click();
        }
      });
    } else {
      this.message = AppMessages.NOT_ACCESS_CAMERA;
    }
  }
  attachVideo(stream) {
    this.cStream = stream;
    this.renderer.setProperty(this.videoElement.nativeElement, 'srcObject', stream);
    this.renderer.listen(this.videoElement.nativeElement, 'play', (event) => {
      this.videoHeight = this.videoElement.nativeElement.videoHeight;
      this.videoWidth = this.videoElement.nativeElement.videoWidth;
    });
  }


  private cropImage2(image: any, iWidth: number, iHeight: number): void
  {
    var rWidth = 720;
    var ratio = iWidth / iHeight;
    rWidth = 720;
    var rHeight = parseInt((rWidth / ratio) + '');
    var canvas: any = document.getElementById('canvasx');
    
    var canvasWidth = rWidth;
    var canvasHeight = rHeight;
    var ctx = canvas.getContext('2d');
    var base = this;
    var rotate = false;
    if(iWidth > iHeight)
    {
      canvasWidth = rHeight;
      canvasHeight = rWidth;
      rotate = true;
    }

    canvas.height = canvasHeight;
    canvas.width = canvasWidth;

    if(rotate)
    {
      ctx.translate(rHeight, 0);
      ctx.rotate( (90 * Math.PI) / 180);
    }
    ctx.drawImage(image,0,0,iWidth,iHeight,0,0,rWidth,rHeight);
    this.stopCamera();
    base.captureEvent.emit(canvas.toDataURL("image/jpeg"));
  }

  private cropImage(image: any): void
  {
    var pictureBill = document.getElementById('imageContainer');
    var width = $(pictureBill).css('width').replace('px','');
    var height = $(pictureBill).css('height').replace('px','');
    var containerRate = parseFloat(height)/parseFloat(width);
    var realImgHeight = containerRate * 720;
    var realY = (1280 - realImgHeight)/2;
    var canvas: any = document.getElementById('canvasx');
    canvas.height = realImgHeight;
    canvas.width = 720;
    var ctx = canvas.getContext('2d');
    var base = this;
    ctx.drawImage(image,0,parseInt(realY + ''), 720, realImgHeight, 0,0, 720, realImgHeight);
    this.stopCamera();
    base.captureEvent.emit(canvas.toDataURL("image/jpeg"));
  }

  public uploadImage(): void
  {
    $('.fileInputProfile').trigger('click');
  }

  public fileChangeEvent(fileInput: any): void {
    if (fileInput.target.files && fileInput.target.files[0]) {
        // Max f
        let max_size = 2097152;
        if(this.staffService.currentCampaignConfig 
          && this.staffService.currentCampaignConfig.maxUploadSize 
          && this.staffService.currentCampaignConfig.maxUploadSize > 0)
        {
          max_size = this.staffService.currentCampaignConfig.maxUploadSize;
        }
        const allowed_types = ['image/png', 'image/jpg', 'image/jpeg'];
        if (fileInput.target.files[0].size > max_size) {
          this.showMessageBox = true;
          this.message = AppMessages.INVALID_FILE_SIZE + " (Tối đa " + (max_size/1024/1024) + 'MB)'
          return;
        }
        if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
          this.showMessageBox = true;
          this.message = AppMessages.INVALID_FILE;
          return;
        }

        const reader = new FileReader();
        reader.onload = (e: any) => {
            const image = new Image();
            image.src = e.target.result;
            image.onload = rs => {
              const imgBase64Path = e.target.result;
              this.captureEvent.emit(imgBase64Path);
            };
        };
        reader.readAsDataURL(fileInput.target.files[0]);
    }
  }


  public async externalCameraHandle(fileInput: any) {
    this.fileSelectorFlg = false;
    if (fileInput.target.files && fileInput.target.files[0]) {
        const allowed_types = ['image/png', 'image/jpg', 'image/jpeg'];
        if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
          this.showMessageBox = true;
          this.message = AppMessages.INVALID_FILE;
          return;
        }
        var drawFile = await this.getImageDimension(fileInput.target.files[0]).toPromise();
        this.cropImage2(drawFile, drawFile.width, drawFile.height);
    }
    else
    {
      this.offCamera();
    }
  }

  getImageDimension(fileInput: any): Observable<any> {
    return new Observable(observer => {
      const reader = new FileReader();
        reader.onload = (e: any) => {
            const image = new Image();
            image.src = e.target.result;
            image.onload = rs => {
              observer.next(image);
              observer.complete();
            };
        };
        reader.readAsDataURL(fileInput);
    });
  }

  public captureImage(){
    const image = this.videoElement.nativeElement;
    this.cropImage(image);
  }

  public offCamera():void{
    if(this.cancelableCamera)
    {
      this.stopCamera();
      this.offCameraEvent.emit();
      if(this.isSkipPII){
        this.router.navigate([`${menuHome.path}`]);
      }
    }
  }

  private stopCamera(): void
  {
    if (this.cStream)
    {
      var video: any = document.getElementById("video");
      if (video)
      {
        video.pause();
        video.src = null;
      }
      const tracks = this.cStream.getVideoTracks();
      tracks.forEach(x => {
        x.stop();
      });
      this.cStream = null;
    }
  }

  public initSwiper(): void
  {
    var mySwiper = new Swiper('.swiper-container');
  }

  public closeMessagePopupEvent(code: any): void
  {
    this.showMessageBox = false;
  }

  public externalCamera(): void
  {
    this.fileSelectorFlg = true;
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    var base = this;
    setTimeout(() => {
      if (base.fileSelectorFlg)
      {
        base.offCamera();
      }
      this.fileSelectorFlg = false;
    }, 500);
  }
}
